// Both saved-view editing and browser-local display settings use the same field mapping/default rules.
import type { EntityViewGantt, MetadataEntityFieldData } from '@jms/model';
import { resolveCalendarDateFields } from '../../../state/features/with.metadata';

export function ganttFormToConfig(existing: EntityViewGantt | undefined, values: Partial<EntityViewGantt> | undefined, fields: MetadataEntityFieldData[]): EntityViewGantt {

  const dateFields = resolveCalendarDateFields(fields);
  const path = (field: MetadataEntityFieldData | undefined) => field?.path ?? field?.name ?? '';
  const startField = values?.startField ?? existing?.startField ?? path(dateFields[0]);
  const finishField = values?.finishField ?? existing?.finishField ?? path(dateFields[1] ?? dateFields[0]);
  const config: EntityViewGantt = {
    ...existing,
    ...values,
    titleField: values?.titleField ?? existing?.titleField ?? path(fields.find(field => (field.path ?? field.name) === 'name') ?? fields[0]),
    startField,
    finishField,
    columns: values?.columns ?? existing?.columns ?? [startField, finishField, values?.contractorField ?? existing?.contractorField, values?.fieldResourcesField ?? existing?.fieldResourcesField].filter((path): path is string => !!path && path !== 'none'),
    taskPane: values?.taskPane ?? existing?.taskPane ?? 'grid',
    scale: values?.scale ?? existing?.scale ?? 'days',
    dateDisplay: values?.dateDisplay ?? existing?.dateDisplay ?? 'date',
  };
  if (config.contractorField === 'none') {
    delete config.contractorField;
  }
  if (config.fieldResourcesField === 'none') {
    delete config.fieldResourcesField;
  }
  return config;
}
